import React, { useState, useEffect, useCallback } from "react";
import EventsGalleryService from "../../../services/EventsGalleryService";
import Loadspinner from "../../../common/Loadspinner";
import Main from "../../../common/Main/Main";
import "./HashtagMaster.css";
// import { useNavigate } from "react-router-dom";
import DynamicGrid from "../../../ReusableComponents/DynamicGrid/DynamicGrid";
import { debounceSearchRender } from "mui-datatables";
import InputForm from "../../../ReusableComponents/InputForm/InputForm";
import { APICall } from "../../../helpers/API/APICalls";
import { getAllHashtagMasterData } from "../../../helpers/API/APIEndPoints";
import { Typography, Tooltip } from "@mui/material";
import { DATE_TIME_DISPLAY_FORMAT, EXCEL_DATE_TIME_FILENAME_FORMAT } from "../../../helpers/Constants/Constants";
import { Encrypt } from "../../../helpers/Cryptography/CryptoJS";
import axios from "axios";
import moment from "moment";
import fileDownload from "js-file-download";
import notify from "../../../ReusableComponents/ToastNotification/ToastNotification";
import { useHistory } from "react-router-dom";
import ErrorLabel from "../../../ReusableComponents/ErrorLabel/ErrorLabel";
import { storeInEncLocalStorage } from "../../../helpers/Utils/Utils";
import { excelDownloadCommon } from "../../../helpers/ExcelDownload/ExcelDownload";

function HashtagMaster() {
  let history = useHistory();
  const [Id, setId] = useState(0);
  const [loading, setLoading] = useState(false);
  const [masterData, setMasterData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [searchText, setSearchText] = useState("");
  const [count, setCount] = useState(0);
  const [Redirectss, setRedirectss] = useState(false);
  const fileExtension = ".xlsx";

  useEffect(() => {
    (async () => {
      setLoading(true);
      let requestParams = {
        start: start,
        resultsPerPage: pageSize,
        searchText: searchText,
        sortColumn: sortColumn,
        sortDirection: sortDirection,
        isExport: false,
      };
      console.log(requestParams);
      let res = await APICall(getAllHashtagMasterData, requestParams, "POST");
      if (res.message === "Ok") {
        if (res && res.data.length > 0 && res.totalCount > 0) {
          setMasterData(res.data);
          setCount(res.totalCount);
        } else {
          setMasterData([]);
          setCount(0);
        }
      } else {
        setMasterData([]);
        setCount(0);
      }
      setLoading(false);
    })();
  }, [start, sortColumn, sortDirection, searchText, count]);

  const exportToExcelFunction = async () => {
    // showLoader();

    // setLoading(true);
    let requestParams = {
      start: 0,
      resultsPerPage: count,
      searchText: searchText,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
      isExport: true,
    };

    // let encryptedParams = await Encrypt(JSON.stringify(requestParams));
    // let reqObj = {
    //   data: encryptedParams,
    // };
    // axios
    //   .request({
    //     method: "POST",
    //     url: getAllHashtagMasterData,
    //     data: reqObj,
    //   })
    //   .then((response) => {
    //     let byteArray = new Uint8Array(response.data.data.data);
    //     fileDownload(
    //       byteArray,
    //       `Hashtag-Master-` +
    //       `${moment(new Date()).format(EXCEL_DATE_TIME_FILENAME_FORMAT)}${fileExtension}`
    //     ); //add time stamp
    //     setLoading(false);
    //   })
    //   .catch((error) => {
    //     // if (error.response.data.data === null) {
    //     setLoading(false);
    //     notify(1, "Error");
    //     // }
    //   });
    // setLoading(false);

        excelDownloadCommon(getAllHashtagMasterData,requestParams,"Hashtag-Master-",setLoading)
    
  };

  const gridColumns = [
    {
      name: "Id",
      label: "ID",
      options: {
        display: false,
      },
    },
    {
      name: "Name",
      label: "Hashtag Name",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "CreatedDate",
      label: "Created Date",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => {
          let dateObj = moment(value);
          let dateStr = dateObj.isValid()
            ? dateObj.format(DATE_TIME_DISPLAY_FORMAT)
            : "";
          return (
            <>
              <Typography component={"span"} noWrap={true} variant="">
                {dateStr}
              </Typography>
            </>
          );
        },
      },
    },
    {
      name: "ModifiedDate",
      label: "Modified Date",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => {
          let dateObj = moment(value);
          let dateStr = dateObj.isValid()
            ? dateObj.format(DATE_TIME_DISPLAY_FORMAT)
            : "";
          return (
            <>
              <Typography component={"span"} noWrap={true} variant="">
                {dateStr}
              </Typography>
            </>
          );
        },
      },
    },
    {
      name: "IsActive",
      label: "Active Status",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
        setCellHeaderProps: () => ({
          style: { textAlign: "center" },
        }),
        customBodyRender: (value) => {
          if (value) {
            return <i className="fas fa-check"></i>;
          } else {
            return <i className="fas fa-times"></i>;
          }
        },
      },
    },
    {
      name: "",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
        setCellHeaderProps: () => ({
          style: { textAlign: "center" },
        }),
        customBodyRender: (value, tableMeta) => {
          let id = tableMeta.tableData[tableMeta.rowIndex].Id;
          console.log(id);
          return (
            <Tooltip title="edit">
              <p className="ml-3">
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    handleClick("hashtag-master/edit", id);
                  }}
                >
                  <i className="fas fa-edit"></i>
                </a>
              </p>
            </Tooltip>
          );
        },
      },
    },
  ];

  const options = {
    selectableRows: "none",
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    customSearchRender: debounceSearchRender(500),
    responsive: "standard",
    onChangeRowsPerPage: () => {
      // num
      //   setLimit(num);
      //   setNxtPgInfo("");
      //   setPrevPgInfo("");
      //   setIsPrevOrNext("");
    },
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
      } else {
        setSearchText("");
      }
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
  };

  async function handleClick(url, Id) {
    storeInEncLocalStorage("tokennumber", await Encrypt(JSON.stringify(Id)));
    history.push({
      pathname: `${url}`,
    });
  }

  return (
    <>
      <Main active={"hashtag_master"} removeContainer={true}>
        <Loadspinner filename="HashtagMaster.js" isLoading={loading} isMiddle="false" />
        <div className="eventGallery">
          <div className="col-lg-12">
            <div className="row">
              <div className="col-md-4">
                <h4 style={{ paddingLeft: "15px" }}>Master</h4>
              </div>
              <div className="col-md-4"></div>

              <div className="col-md-4" style={{ padding: "0% 3% 0% 0%" }}>
                <div
                  className="float-right col-sm-offset-2"
                  style={{
                    marginBottom: 10,
                  }}
                >
                  <button
                    className="btn btn-export"
                    style={{ marginLeft: 5 }}
                    onClick={() => exportToExcelFunction()}
                  >
                    Export To Excel
                  </button>
                  <button
                    className="btn btn-danger"
                    style={{
                      marginLeft: 5,
                    }}
                    onClick={() => handleClick("hashtag-master/edit", 0)}
                  >
                    + Create
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="clearfix"></div>
        <div
          className="d-flex align-items-center justify-space-between"
          style={{
            background: "#e61636",
            padding: "10px 20px 10px 10px",
            color: "white",
          }}
        >
          <div className="col-lg-8" style={{ paddingLeft: "5px" }}>
            Hashtag
          </div>
          <div className="d-flex w-100 justify-content-end align-items-center mr-xl-3 mr-md-3">
            <div className="w-100 col-lg-12 col-sm-5 col-xs-10 searchInput">
              <InputForm
                value={searchText}
                placeholder={"Search"}
                isDisabled={false}
                textArea={false}
                onChange={(e) => {
                  if (e.target.value) {
                    setSearchText(e.target.value);
                  } else {
                    setSearchText("");
                  }
                }}
              />
              <i
                style={{ marginRight: "-10px", marginTop: "-3px" }}
                className="fas fa-search"
                aria-hidden="true"
              ></i>
            </div>
          </div>
        </div>

        <div>
          {masterData && masterData.length >= 0 && (
            <DynamicGrid
              options={options}
              data={masterData}
              columns={gridColumns}
            />
          )}
        </div>
      </Main>
    </>
  );
}

export default HashtagMaster;
